"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true,
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _types = require("./types");
var _ui = require("../ui");
var _styles = require("./styles");
var _Signin = _interopRequireDefault(require("./components/Signin/Signin"));
var _ForgotPassword = _interopRequireDefault(require("./components/ForgotPassword"));
var _ResetPassword = _interopRequireDefault(require("./components/ResetPassword"));
var _ConfirmAccount = _interopRequireDefault(require("./components/ConfirmAccount"));
var _NewPassword = _interopRequireDefault(require("./components/NewPassword"));
var _ProblemSigningIn = _interopRequireDefault(require("./components/ProblemSigningIn"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || ("object" != _typeof(e) && "function" != typeof e)) return { default: e };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = { __proto__: null },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e)
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : (n[u] = e[u]);
    }
  return (n["default"] = e), t && t.set(e, n), n;
}
function _typeof(o) {
  "@babel/helpers - typeof";
  return (
    (_typeof =
      "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
        ? function (o) {
            return typeof o;
          }
        : function (o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype
              ? "symbol"
              : typeof o;
          }),
    _typeof(o)
  );
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    if (r) {
      o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      });
    }
    t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2
      ? ownKeys(Object(t), !0).forEach(function (r) {
          _defineProperty(e, r, t[r]);
        })
      : Object.getOwnPropertyDescriptors
        ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t))
        : ownKeys(Object(t)).forEach(function (r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
          });
  }
  return e;
}
function _regeneratorRuntime() {
  "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o =
      Object.defineProperty ||
      function (t, e, r) {
        t[e] = r.value;
      },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return (t[e] = r);
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return { type: "normal", arg: t.call(e, r) };
    } catch (t) {
      return { type: "throw", arg: t };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = (GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p));
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await")
          ? e.resolve(h.__await).then(
              function (t) {
                invoke("next", t, i, a);
              },
              function (t) {
                invoke("throw", t, i, a);
              },
            )
          : e.resolve(h).then(
              function (t) {
                u.value = t;
                i(u);
              },
              function (t) {
                return invoke("throw", t, i, a);
              },
            );
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return (r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg());
      },
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return { value: t, done: !0 };
      }
      for (n.method = i, n.arg = a; ; ) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;
        else if ("throw" === n.method) {
          if (o === h) throw ((o = s), n.arg);
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (((o = n.done ? s : l), p.arg === y)) continue;
          return { value: p.arg, done: n.done };
        }
        if ("throw" === p.type) {
          o = s;
          n.method = "throw";
          n.arg = p.arg;
        }
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t)
      return (
        (r.delegate = null),
        ("throw" === n &&
          e.iterator["return"] &&
          ((r.method = "return"), (r.arg = t), maybeInvokeDelegate(e, r), "throw" === r.method)) ||
          ("return" !== n &&
            ((r.method = "throw"), (r.arg = new TypeError("The iterator does not provide a '" + n + "' method")))),
        y
      );
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return (r.method = "throw"), (r.arg = i.arg), (r.delegate = null), y;
    var a = i.arg;
    return a
      ? a.done
        ? ((r[e.resultName] = a.value),
          (r.next = e.nextLoc),
          "return" !== r.method && ((r.method = "next"), (r.arg = t)),
          (r.delegate = null),
          y)
        : a
      : ((r.method = "throw"), (r.arg = new TypeError("iterator result is not an object")), (r.delegate = null), y);
  }
  function pushTryEntry(t) {
    var e = { tryLoc: t[0] };
    if (1 in t) {
      e.catchLoc = t[1];
    }
    if (2 in t) {
      e.finallyLoc = t[2];
      e.afterLoc = t[3];
    }
    this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal";
    delete e.arg;
    t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{ tryLoc: "root" }];
    t.forEach(pushTryEntry, this);
    this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length; ) if (n.call(e, o)) return (next.value = e[o]), (next.done = !1), next;
            return (next.value = t), (next.done = !0), next;
          };
        return (i.next = i);
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return (
    (GeneratorFunction.prototype = GeneratorFunctionPrototype),
    o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }),
    o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }),
    (GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction")),
    (e.isGeneratorFunction = function (t) {
      var e = "function" == typeof t && t.constructor;
      return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }),
    (e.mark = function (t) {
      return (
        Object.setPrototypeOf
          ? Object.setPrototypeOf(t, GeneratorFunctionPrototype)
          : ((t.__proto__ = GeneratorFunctionPrototype), define(t, u, "GeneratorFunction")),
        (t.prototype = Object.create(g)),
        t
      );
    }),
    (e.awrap = function (t) {
      return { __await: t };
    }),
    defineIteratorMethods(AsyncIterator.prototype),
    define(AsyncIterator.prototype, c, function () {
      return this;
    }),
    (e.AsyncIterator = AsyncIterator),
    (e.async = function (t, r, n, o, i) {
      void 0 === i && (i = Promise);
      var a = new AsyncIterator(wrap(t, r, n, o), i);
      return e.isGeneratorFunction(r)
        ? a
        : a.next().then(function (t) {
            return t.done ? t.value : a.next();
          });
    }),
    defineIteratorMethods(g),
    define(g, u, "Generator"),
    define(g, a, function () {
      return this;
    }),
    define(g, "toString", function () {
      return "[object Generator]";
    }),
    (e.keys = function (t) {
      var e = Object(t),
        r = [];
      for (var n in e) r.push(n);
      return (
        r.reverse(),
        function next() {
          for (; r.length; ) {
            var t = r.pop();
            if (t in e) return (next.value = t), (next.done = !1), next;
          }
          return (next.done = !0), next;
        }
      );
    }),
    (e.values = values),
    (Context.prototype = {
      constructor: Context,
      reset: function reset(e) {
        if (
          ((this.prev = 0),
          (this.next = 0),
          (this.sent = this._sent = t),
          (this.done = !1),
          (this.delegate = null),
          (this.method = "next"),
          (this.arg = t),
          this.tryEntries.forEach(resetTryEntry),
          !e)
        )
          for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
      },
      stop: function stop() {
        this.done = !0;
        var t = this.tryEntries[0].completion;
        if ("throw" === t.type) throw t.arg;
        return this.rval;
      },
      dispatchException: function dispatchException(e) {
        if (this.done) throw e;
        var r = this;
        function handle(n, o) {
          return (a.type = "throw"), (a.arg = e), (r.next = n), o && ((r.method = "next"), (r.arg = t)), !!o;
        }
        for (var o = this.tryEntries.length - 1; o >= 0; --o) {
          var i = this.tryEntries[o],
            a = i.completion;
          if ("root" === i.tryLoc) return handle("end");
          if (i.tryLoc <= this.prev) {
            var c = n.call(i, "catchLoc"),
              u = n.call(i, "finallyLoc");
            if (c && u) {
              if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
              if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
            } else if (c) {
              if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            } else {
              if (!u) throw new Error("try statement without catch or finally");
              if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
            }
          }
        }
      },
      abrupt: function abrupt(t, e) {
        for (var r = this.tryEntries.length - 1; r >= 0; --r) {
          var o = this.tryEntries[r];
          if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
            var i = o;
            break;
          }
        }
        i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
        var a = i ? i.completion : {};
        return (
          (a.type = t), (a.arg = e), i ? ((this.method = "next"), (this.next = i.finallyLoc), y) : this.complete(a)
        );
      },
      complete: function complete(t, e) {
        if ("throw" === t.type) throw t.arg;
        return (
          "break" === t.type || "continue" === t.type
            ? (this.next = t.arg)
            : "return" === t.type
              ? ((this.rval = this.arg = t.arg), (this.method = "return"), (this.next = "end"))
              : "normal" === t.type && e && (this.next = e),
          y
        );
      },
      finish: function finish(t) {
        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
          var r = this.tryEntries[e];
          if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
        }
      },
      catch: function _catch(t) {
        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
          var r = this.tryEntries[e];
          if (r.tryLoc === t) {
            var n = r.completion;
            if ("throw" === n.type) {
              var o = n.arg;
              resetTryEntry(r);
            }
            return o;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(e, r, n) {
        return (
          (this.delegate = { iterator: values(e), resultName: r, nextLoc: n }),
          "next" === this.method && (this.arg = t),
          y
        );
      },
    }),
    e
  );
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _slicedToArray(arr, i) {
  return (
    _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest()
  );
}
function _nonIterableRest() {
  throw new TypeError(
    "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
  );
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : ("undefined" != typeof Symbol && r[Symbol.iterator]) || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (((i = (t = t.call(r)).next), 0 === l)) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0;
      n = r;
    } finally {
      try {
        if (!f && null != t["return"] && ((u = t["return"]()), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
} // Custom Imports
var AuthHeaderLookup = _defineProperty(
  _defineProperty(
    _defineProperty(
      _defineProperty(
        _defineProperty(
          _defineProperty({}, _types.AuthModeType.SIGN_IN, "Sign In"),
          _types.AuthModeType.FORGOT_PASSWORD,
          "Forgot Password",
        ),
        _types.AuthModeType.RESET_PASSWORD,
        "Reset Password",
      ),
      _types.AuthModeType.CONFIRM_ACCOUNT,
      "User Verification",
    ),
    _types.AuthModeType.NEW_PASSWORD_REQUIRED,
    "Set New Password",
  ),
  _types.AuthModeType.PROBLEM_SIGNING_IN,
  "Contact Us",
);
var Auth = function Auth(_ref) {
  var context = _ref.context,
    enabledUserGroups = _ref.enabledUserGroups,
    handleSnackbar = _ref.handleSnackbar,
    versionNumber = _ref.versionNumber,
    additionalLoading = _ref.loading,
    children = _ref.children;
  var classes = (0, _styles.useStyles)();
  var _useContext = (0, _react.useContext)(context),
    authService = _useContext.authService,
    user = _useContext.user,
    setCredentials = _useContext.setCredentials;
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    authenticated = _useState4[0],
    setAuthenticated = _useState4[1];
  var _useState5 = (0, _react.useState)(_types.AuthModeType.SIGN_IN),
    _useState6 = _slicedToArray(_useState5, 2),
    authMode = _useState6[0],
    setAuthMode = _useState6[1];
  var _useState7 = (0, _react.useState)(0),
    _useState8 = _slicedToArray(_useState7, 2),
    loginAttemptCount = _useState8[0],
    setLoginAttemptCount = _useState8[1];
  var signInSuccessCallback = (0, _react.useCallback)(
    /*#__PURE__*/ (function () {
      var _ref2 = _asyncToGenerator(
        /*#__PURE__*/ _regeneratorRuntime().mark(function _callee(userRes) {
          var _userRes$getSignInUse;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1)
              switch ((_context.prev = _context.next)) {
                case 0:
                  _context.t0 = userRes.challengeName;
                  _context.next = _context.t0 === "SMS_MFA" ? 3 : _context.t0 === "NEW_PASSWORD_REQUIRED" ? 5 : 7;
                  break;
                case 3:
                  setAuthMode(_types.AuthModeType.CONFIRM_ACCOUNT);
                  return _context.abrupt("return", _types.AuthResponse.CONFIRM_ACCOUNT);
                case 5:
                  setAuthMode(_types.AuthModeType.NEW_PASSWORD_REQUIRED);
                  return _context.abrupt("return", _types.AuthResponse.NEW_PASSWORD_REQUIRED);
                case 7:
                  if (
                    !(
                      enabledUserGroups &&
                      enabledUserGroups.length > 0 &&
                      !(
                        (_userRes$getSignInUse = userRes.getSignInUserSession()) != null &&
                        _userRes$getSignInUse.getIdToken().payload["cognito:groups"].some(function (group) {
                          return enabledUserGroups.includes(group);
                        })
                      )
                    )
                  ) {
                    _context.next = 12;
                    break;
                  }
                  _context.next = 10;
                  return authService.signout();
                case 10:
                  handleSnackbar("error", "Invalid username or password");
                  return _context.abrupt("return", _types.AuthResponse.FAILED);
                case 12:
                  return _context.abrupt("return", _types.AuthResponse.SUCCESS);
                case 13:
                case "end":
                  return _context.stop();
              }
          }, _callee);
        }),
      );
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    })(),
    [authService, enabledUserGroups, handleSnackbar, setAuthMode, setCredentials],
  );
  var handleSignIn = (0, _react.useCallback)(
    /*#__PURE__*/ (function () {
      var _ref3 = _asyncToGenerator(
        /*#__PURE__*/ _regeneratorRuntime().mark(function _callee2(values) {
          var email, password, username, signInRes, successRes, numberOfAttempts, attempts;
          return _regeneratorRuntime().wrap(
            function _callee2$(_context2) {
              while (1)
                switch ((_context2.prev = _context2.next)) {
                  case 0:
                    email = values.email;
                    password = values.password;
                    username =
                      // check if it is a zero-based phone number, not an email
                      email.indexOf("0") === 0 && email.indexOf("@") === -1
                        ? "+44" + email.slice(1)
                        : email.toLowerCase();
                    _context2.prev = 2;
                    _context2.next = 5;
                    return authService.signin(username, password);
                  case 5:
                    signInRes = _context2.sent;
                    _context2.next = 8;
                    return signInSuccessCallback(signInRes);
                  case 8:
                    successRes = _context2.sent;
                    // If sign in response is successful we will set the credentials
                    // We do this afterwards so there is no flicker if the user doesn't belong in the same group
                    if (successRes !== _types.AuthResponse.FAILED) {
                      setCredentials(signInRes);
                    }
                    return _context2.abrupt("return", successRes);
                  case 13:
                    _context2.prev = 13;
                    _context2.t0 = _context2["catch"](2);
                    _context2.t1 = _context2.t0.code;
                    _context2.next =
                      _context2.t1 === "UserNotConfirmedException"
                        ? 18
                        : _context2.t1 === "PasswordResetRequiredException"
                          ? 22
                          : _context2.t1 === "NotAuthorizedException"
                            ? 25
                            : 33;
                    break;
                  case 18:
                    _context2.next = 20;
                    return authService.resendSignup(username, password);
                  case 20:
                    setAuthMode(_types.AuthModeType.CONFIRM_ACCOUNT);
                    return _context2.abrupt("return", _types.AuthResponse.CONFIRM_ACCOUNT);
                  case 22:
                    _context2.next = 24;
                    return authService
                      .forgotPassword(username)
                      .then(function () {
                        handleSnackbar("success", "A temporary password has been sent to your email");
                        return _types.AuthResponse.NEW_PASSWORD_REQUIRED;
                      })
                      ["catch"](function () {
                        handleSnackbar(
                          "error",
                          "Could not set new password. Ensure internet connection or contact support.",
                        );
                        return _types.AuthResponse.FAILED;
                      });
                  case 24:
                    return _context2.abrupt("return", _context2.sent);
                  case 25:
                    numberOfAttempts = Number(localStorage.getItem(username.toLowerCase().trim()));
                    attempts = 1;
                    if (numberOfAttempts) {
                      attempts = numberOfAttempts + 1;
                    }
                    localStorage.setItem(username.toLowerCase().trim(), attempts.toString());
                    localStorage.setItem("loginEmail", username.toLowerCase().trim());
                    setLoginAttemptCount(attempts);

                    // Prevent double snackbar, in the future we can have stacking
                    // Snackbars but at the moment we don't have this
                    if (numberOfAttempts <= 4) {
                      handleSnackbar("error", "Invalid username or password");
                    }
                    return _context2.abrupt("return", _types.AuthResponse.FAILED);
                  case 33:
                    handleSnackbar("error", "Invalid username or password");
                    return _context2.abrupt("return", _types.AuthResponse.FAILED);
                  case 35:
                  case "end":
                    return _context2.stop();
                }
            },
            _callee2,
            null,
            [[2, 13]],
          );
        }),
      );
      return function (_x2) {
        return _ref3.apply(this, arguments);
      };
    })(),
    [authService, enabledUserGroups, handleSnackbar, setCredentials],
  );
  var handleForgotPassword = (0, _react.useCallback)(
    /*#__PURE__*/ (function () {
      var _ref4 = _asyncToGenerator(
        /*#__PURE__*/ _regeneratorRuntime().mark(function _callee3(values) {
          return _regeneratorRuntime().wrap(
            function _callee3$(_context3) {
              while (1)
                switch ((_context3.prev = _context3.next)) {
                  case 0:
                    _context3.prev = 0;
                    _context3.next = 3;
                    return authService.forgotPassword(values.email);
                  case 3:
                    setAuthMode(_types.AuthModeType.RESET_PASSWORD);
                    _context3.next = 10;
                    break;
                  case 6:
                    _context3.prev = 6;
                    _context3.t0 = _context3["catch"](0);
                    handleSnackbar("error", "Attempt limit exceeded, please try again after some time.");
                    setAuthMode(_types.AuthModeType.SIGN_IN);
                  case 10:
                  case "end":
                    return _context3.stop();
                }
            },
            _callee3,
            null,
            [[0, 6]],
          );
        }),
      );
      return function (_x3) {
        return _ref4.apply(this, arguments);
      };
    })(),
    [authService, handleSnackbar, setAuthMode],
  );
  var handleResetPassword = (0, _react.useCallback)(
    /*#__PURE__*/ (function () {
      var _ref5 = _asyncToGenerator(
        /*#__PURE__*/ _regeneratorRuntime().mark(function _callee4(values) {
          var verificationCode, password, passwordChangeRes;
          return _regeneratorRuntime().wrap(function _callee4$(_context4) {
            while (1)
              switch ((_context4.prev = _context4.next)) {
                case 0:
                  verificationCode = values.verificationCode;
                  password = values.password;
                  _context4.next = 3;
                  return authService.resetPassword(verificationCode, password);
                case 3:
                  passwordChangeRes = _context4.sent;
                  if (passwordChangeRes) {
                    _context4.next = 7;
                    break;
                  }
                  handleSnackbar("error", "Password change not successful");
                  return _context4.abrupt("return", _types.AuthResponse.FAILED);
                case 7:
                  handleSnackbar("success", "Password reset successful");
                  setAuthMode(_types.AuthModeType.SIGN_IN);
                case 9:
                case "end":
                  return _context4.stop();
              }
          }, _callee4);
        }),
      );
      return function (_x4) {
        return _ref5.apply(this, arguments);
      };
    })(),
    [authService, setCredentials, handleSnackbar],
  );
  var handleConfirmAccount = (0, _react.useCallback)(
    /*#__PURE__*/ (function () {
      var _ref6 = _asyncToGenerator(
        /*#__PURE__*/ _regeneratorRuntime().mark(function _callee5(values) {
          var verificationCode, confirmAccount;
          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while (1)
              switch ((_context5.prev = _context5.next)) {
                case 0:
                  verificationCode = values.verificationCode;
                  _context5.next = 3;
                  return authService.confirmAccount(user, verificationCode);
                case 3:
                  confirmAccount = _context5.sent;
                  if (confirmAccount) {
                    _context5.next = 7;
                    break;
                  }
                  handleSnackbar("error", "Invalid code please try again");
                  return _context5.abrupt("return", _types.AuthResponse.FAILED);
                case 7:
                  setCredentials(_objectSpread({}, confirmAccount));

                  // Reset auth mode to sign in
                  setAuthMode(_types.AuthModeType.SIGN_IN);
                case 9:
                case "end":
                  return _context5.stop();
              }
          }, _callee5);
        }),
      );
      return function (_x5) {
        return _ref6.apply(this, arguments);
      };
    })(),
    [authService, setCredentials, handleSnackbar, user],
  );
  var handleCompleteNewPassword = (0, _react.useCallback)(
    /*#__PURE__*/ (function () {
      var _ref7 = _asyncToGenerator(
        /*#__PURE__*/ _regeneratorRuntime().mark(function _callee6(values) {
          var password, newPasswordRes, signInRes, currentUser;
          return _regeneratorRuntime().wrap(function _callee6$(_context6) {
            while (1)
              switch ((_context6.prev = _context6.next)) {
                case 0:
                  password = values.password;
                  _context6.next = 3;
                  return authService.completeNewPassword(user, password);
                case 3:
                  newPasswordRes = _context6.sent;
                  if (newPasswordRes) {
                    _context6.next = 7;
                    break;
                  }
                  handleSnackbar("error", "Password change not successful");
                  return _context6.abrupt("return", _types.AuthResponse.FAILED);
                case 7:
                  _context6.next = 9;
                  return signInSuccessCallback(newPasswordRes);
                case 9:
                  signInRes = _context6.sent;
                  if (!signInRes) {
                    _context6.next = 15;
                    break;
                  }
                  _context6.next = 13;
                  return authService.currentUserPoolUser();
                case 13:
                  currentUser = _context6.sent;
                  if (currentUser) {
                    setCredentials(_objectSpread({}, currentUser));
                  }
                case 15:
                case "end":
                  return _context6.stop();
              }
          }, _callee6);
        }),
      );
      return function (_x6) {
        return _ref7.apply(this, arguments);
      };
    })(),
    [authService, setCredentials, handleSnackbar, user],
  );

  // Handles password resets after more than 5 wrong attempts to sign in
  (0, _react.useEffect)(
    function () {
      function handleWrongAttempts() {
        return _handleWrongAttempts.apply(this, arguments);
      }
      function _handleWrongAttempts() {
        _handleWrongAttempts = _asyncToGenerator(
          /*#__PURE__*/ _regeneratorRuntime().mark(function _callee7() {
            var email;
            return _regeneratorRuntime().wrap(function _callee7$(_context7) {
              while (1)
                switch ((_context7.prev = _context7.next)) {
                  case 0:
                    email = localStorage.getItem("loginEmail"); // safe cast here as this own't be able to be triggered without loginEmail being present
                    // in local storage
                    _context7.next = 3;
                    return handleForgotPassword({
                      email: email,
                    });
                  case 3:
                    handleSnackbar(
                      "error",
                      "You have failed to login too many times and your account has been locked.",
                    );
                  case 4:
                  case "end":
                    return _context7.stop();
                }
            }, _callee7);
          }),
        );
        return _handleWrongAttempts.apply(this, arguments);
      }
      if (loginAttemptCount > 4) {
        handleWrongAttempts();
      }
    },
    [handleForgotPassword, handleSnackbar, loginAttemptCount],
  );

  // Handles initial load of the application
  (0, _react.useEffect)(
    function () {
      function loadApplication() {
        return _loadApplication.apply(this, arguments);
      }
      function _loadApplication() {
        _loadApplication = _asyncToGenerator(
          /*#__PURE__*/ _regeneratorRuntime().mark(function _callee8() {
            var isAuthenticated, _user;
            return _regeneratorRuntime().wrap(
              function _callee8$(_context8) {
                while (1)
                  switch ((_context8.prev = _context8.next)) {
                    case 0:
                      _context8.prev = 0;
                      setLoading(true);
                      _context8.next = 4;
                      return authService.isAuthenticated();
                    case 4:
                      isAuthenticated = _context8.sent;
                      if (!(!user && isAuthenticated)) {
                        _context8.next = 10;
                        break;
                      }
                      _context8.next = 8;
                      return authService.currentUserPoolUser();
                    case 8:
                      _user = _context8.sent;
                      setCredentials(_objectSpread({}, _user));
                    case 10:
                      setAuthenticated(isAuthenticated);
                      setLoading(false);
                      _context8.next = 17;
                      break;
                    case 14:
                      _context8.prev = 14;
                      _context8.t0 = _context8["catch"](0);
                      console.error(_context8.t0);
                    case 17:
                    case "end":
                      return _context8.stop();
                  }
              },
              _callee8,
              null,
              [[0, 14]],
            );
          }),
        );
        return _loadApplication.apply(this, arguments);
      }
      loadApplication();
    },
    [authService, setCredentials, user],
  );
  if (loading || additionalLoading) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ui.LoadingCircle, {});
  }
  if (authenticated) {
    return children;
  }
  return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_material.Container, {
    component: "main",
    maxWidth: false,
    className: classes.root,
    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_material.Card, {
      className: classes.paper,
      elevation: 0,
      children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: classes.contentContainer,
        children: [
          /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ui.Logo, {
            size: 60,
          }),
          /*#__PURE__*/ (0, _jsxRuntime.jsx)(_material.Typography, {
            component: "h3",
            variant: "h3",
            className: classes.textWhite,
            mt: 2,
            children: AuthHeaderLookup[authMode],
          }),
          /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: classes.form,
            children:
              authMode === _types.AuthModeType.SIGN_IN
                ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Signin["default"], {
                    setAuthMode: setAuthMode,
                    handleSignIn: handleSignIn,
                  })
                : authMode === _types.AuthModeType.FORGOT_PASSWORD
                  ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ForgotPassword["default"], {
                      setAuthMode: setAuthMode,
                      handleForgotPassword: handleForgotPassword,
                    })
                  : authMode === _types.AuthModeType.RESET_PASSWORD
                    ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ResetPassword["default"], {
                        setAuthMode: setAuthMode,
                        handleResetPassword: handleResetPassword,
                      })
                    : authMode === _types.AuthModeType.CONFIRM_ACCOUNT
                      ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ConfirmAccount["default"], {
                          setAuthMode: setAuthMode,
                          handleConfirmAccount: handleConfirmAccount,
                        })
                      : authMode === _types.AuthModeType.NEW_PASSWORD_REQUIRED
                        ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_NewPassword["default"], {
                            setAuthMode: setAuthMode,
                            handleCompleteNewPassword: handleCompleteNewPassword,
                          })
                        : authMode === _types.AuthModeType.PROBLEM_SIGNING_IN
                          ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ProblemSigningIn["default"], {
                              setAuthMode: setAuthMode,
                              versionNumber: versionNumber,
                            })
                          : /*#__PURE__*/ (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {}),
          }),
        ],
      }),
    }),
  });
};
var _default = (exports["default"] = /*#__PURE__*/ _react["default"].memo(Auth));
